import './App.css';
import Postergrid from './components/postergrid';

function App() {
  return (
    <div className="App">
        <Postergrid />
    </div>
  );
}

export default App;
